import { render } from "./inspectionStepProductImageModal.vue?vue&type=template&id=1925fb8c&scoped=true&ts=true"
import script from "./inspectionStepProductImageModal.vue?vue&type=script&lang=ts"
export * from "./inspectionStepProductImageModal.vue?vue&type=script&lang=ts"

import "./inspectionStepProductImageModal.vue?vue&type=style&index=0&id=1925fb8c&lang=scss&scoped=true"
import "./inspectionStepProductImageModal.vue?vue&type=style&index=1&id=1925fb8c&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1925fb8c"]])

export default __exports__